import { Account } from "library/accounts/types";
import { Product } from "library/hooks/types";
import { UseQueryResult } from "react-query";

export const getProductCodes = (
  productList: Account[],
  productsInfo: UseQueryResult<Product[]>,
) =>
  (productList || [])
    .map(
      (product) =>
        productsInfo?.data?.find(({ id }) => id === product.product_id)?.code,
    )
    .filter(Boolean) as string[];
